import * as APICommands from "../../APICommands/index.js";
import { findEventually } from "../AMasterIndex.js";
import type { Zone } from "../Zone.js";
import { BlockValveOptions } from "./BlockValve.js";
import { IrrigationDeviceBase } from "./IrrigationDeviceBase.js";

export class IrrigationDevice extends IrrigationDeviceBase {
    /**
     * Bottom zone (V1), top zone  (V2)
     * @type {Zone[]}
     */
    zonesByValve: Zone[] = [];
    /**
     * Creates a new entity of this type and sends it to the server. When the server accepts the new entity, a new local entity
     * is created and this function returns.
     */
    static async createNew(options: BlockValveOptions) {
        return await APICommands.DeviceAPI.addOne(options).then((r) => new IrrigationDevice(r));
    }
    constructor(json) {
        super(json);
        this.category = "irrigationDevice";
        this.load().catch((e) => {
            console.warn(e);
        });
    }

    async load() {
        this.zonesByValve = [undefined, undefined];
        const connectedZones = this.connectedZoneIDs;
        const promises = [];
        connectedZones.forEach((cz, i) => {
            promises.push(
                findEventually("zone", cz)
                    .then((r) => {
                        this.zonesByValve[i] = r;
                        r.devices.push(this);
                    })
                    .catch(() => {
                        console.warn(`Zone ${cz} not found or not loaded`);
                    }),
            );
        });
        await Promise.all(promises);
        await super.load();
    }

    /**
     * Deletes this entity and returns when the entity has been deleted from the server.
     */
    async delete() {
        await APICommands.DeviceAPI.deleteOne(this.id).then(() => {
            super.delete();
        });
    }

    async edit(args: Record<string, unknown>) {
        const json = await APICommands.DeviceAPI.editOne(this.dbID, args);
        this.lastRefreshed = new Date(Date.now());
        this.assignFromJSON(json);
        this.onChange.trigger({});
        return this;
    }

    // /**
    //  *
    //  * @param  {{lat, lng}[]} newVertices
    //  * @param {String} newName
    //  * @return {Promise<void>}
    //  */
    // async edit(newVertices=undefined, newName=undefined){
    //     await APICommands.zones.editOne(this.dbID, newName, undefined, newVertices).then((r)=>{
    //         this.name = r.label;
    //         this.vertices = r.vertices[0];
    //         this.onChange.trigger({target: this});
    //     })
    //
    // }
}
